import React from 'react'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import { Helmet } from 'react-helmet'

import { routes } from '../routes'
import rootReducer from '../ducks'
import styles from './app.css'

const PAGE_TITLE = 'invoiz.de'

const App = () => {
  const store = createStore(rootReducer)

  return (
    <Provider store={store}>
      <div className={styles.layout}>
        <Helmet
          defaultTemplate={PAGE_TITLE}
          titleTemplate={`%s - ${PAGE_TITLE}`}
          >
          <meta charSet='utf8' />
        </Helmet>
        {routes()}
      </div>
    </Provider>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/components/app.jsx